import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import SignupOptions from "./SignupOptionsWeb";
import SignupTitle from "../SignupTitle";
import SingupBoxInfoWeb from "./SignupBoxInfoWeb";

const Container = styled.div`
  max-width: 665px;
`;

const Wrapper = styled.div`
  background: ${({ theme }) => theme.backgroundColor};
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.4);
  padding: 0 40px 0 40px;
  border-radius: 10px;
  display: grid;
  row-gap: 30px;
  max-width: 585px;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    max-width: 415px;
    column-gap: 30px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 365px;
    column-gap: 30px;
  }
`;

const SignupBoxWeb = () => {
  const { t } = useTranslation();
  return (
    <Container id="signup-box">
      <Wrapper>
        <SignupTitle
          title={t("signup-box-title")}
          description={t("signup-box-description")}
        />
        <SignupOptions />
        <SingupBoxInfoWeb>{t("signup-box-info")}</SingupBoxInfoWeb>
      </Wrapper>
    </Container>
  );
};

export default SignupBoxWeb;
